import React from "react";
interface PanelProps {
  isMobile?: boolean;
}
interface PanelContainerProps extends PanelProps {
  title: string;
  description: React.ReactNode;
  icon: React.ReactNode;
  children?: React.ReactNode;
}
export const PanelContainer: React.FC<PanelContainerProps> = ({
  isMobile,
  title,
  description,
  icon,
  children
}) => {
  return <div className={["rounded-lg bg-background", isMobile ? "mx-4 h-[calc(100dvh-120px)] overflow-y-auto px-4 py-2" : "md:h-[calc(100vh-135px)] overflow-y-auto px-4 py-2"].filter(Boolean).join(" ")}>
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-4">
        

        {children && <div>{children}</div>}
      </div>
    </div>;
};